// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"169":"16deed7c","453":"e9d2bcb6"}[chunkId] + ".chunk.js";
};